import { css } from "styled-components"

export const rowHeight = 35
export const topMargin = 35

export const zIndexHeader = 20
export const zIndexStickyCell = 10

export const stickyCell = (stickyPosition?: number, isLastSticky?: boolean) => css`
  position: ${stickyPosition === undefined ? "relative" : "sticky"};
  left: ${stickyPosition === undefined ? "auto" : `${stickyPosition}px`};
  ${stickyPosition !== undefined ? `z-index: ${zIndexStickyCell};` : ""}
  box-shadow: ${isLastSticky != null && isLastSticky ? `4px 0px 4px rgba(0, 0, 0, 0.1); z-index: 10;` : "none"};
`
